<template>
  <div class="drag-area">
    <svg-placeholder class="drag-area__svg" />
    <main-content class="drag-area__content" />
  </div>
</template>

<script>
  import SvgPlaceholder from './svg-placehoder';
  import MainContent from './main-content';

  export default {
    components: { SvgPlaceholder, MainContent },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    }
  };
</script>

<style lang="scss">
  .drag-area {
    z-index: 3;
    position: relative;

    &__svg {
      z-index: 2;
    }
  }
</style>
